const searchResultElem = document.querySelector('.search-result');

if (searchResultElem) {
  const searchFilterButtons = searchResultElem.querySelectorAll('.search-result__filter-btn');
  const searchInput = searchResultElem.querySelector('#searchTerm');

  const axiosGetSearchResult = async (searchTerm, searchCpt, searchCategory) => {
    const cptFilterElem = searchResultElem.querySelector('[data-cpt-filter]');
    const categoryFilterElem = searchResultElem.querySelector('[data-category-filter]');
    const searchResultBody = searchResultElem.querySelector('.search-result__body');
    const noResultElem = searchResultElem.querySelector('.search-result__empty');

    const formDataInput = {
      action: 'getSearchResultPosts',
      nonce: await getNonceForAction('getSearchResultPosts'),
      searchTerm,
      searchCpt,
      searchCategory,
    };

    try {
      const { data } = await axios.post(localData.siteURL, formDataInput);
      searchResultBody.innerHTML = '';
      categoryFilterElem.innerHTML = '';

      if (data.data.show_cpt_filter) {
        cptFilterElem.classList.remove('hide');
      } else {
        cptFilterElem.classList.add('hide');
      }

      if (data.data.html_category_filter) {
        categoryFilterElem.classList.remove('hide');
        categoryFilterElem.innerHTML = data.data.html_category_filter;
      } else {
        categoryFilterElem.classList.add('hide');
      }

      if (searchResultBody && data.data.html_list) {
        searchResultBody.innerHTML = data.data.html_list;
        noResultElem.classList.add('hide');
      }

      if (noResultElem && !data.data.html_list) {
        const emptyTitle = searchResultElem.querySelector('.search-result__empty-title');

        if (emptyTitle) {
          const strongElem = emptyTitle.querySelector('strong');

          if (strongElem) {
            strongElem.textContent = `“${searchTerm}”`;
          } else {
            emptyTitle.innerHTML = `${emptyTitle.innerHTML.replace(
              /”?\.*$/, // removes old quote or dot at the end
              '',
            )} <strong>“${searchTerm}”</strong>.`;
          }
        }

        noResultElem.classList.remove('hide');
      }

      const [baseUrl] = window.location.href.split('?');
      const urlParams = ['searchTerm', 'searchCpt', 'searchCategory']
        .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
        .map((item) => `${item}=${encodeURIComponent(formDataInput[item])}`)
        .join('&');

      window.history.pushState({}, '', baseUrl + (urlParams ? `?${urlParams}` : ''));
      searchResultElem.scrollIntoView();
    } catch (err) {
      console.error(err);
    }
  };

  const getActiveFilterValue = (selector) => {
    const activeBtn = searchResultElem.querySelector(`${selector} .search-result__filter-btn.is-active`);
    return activeBtn?.getAttribute('data-filter') || '';
  };

  const getSearchTerm = () => searchInput?.value.trim() || '';

  const triggerSearch = () => {
    const searchTerm = getSearchTerm();
    const searchCpt = getActiveFilterValue('.search-result__filter');
    const searchCategory = getActiveFilterValue('.search-result__sub-filter');

    axiosGetSearchResult(searchTerm, searchCpt, searchCategory);
  };

  // Search Submit
  const searchFormSubmitBtn = document.querySelector('.btn--search');
  if (searchFormSubmitBtn) {
    searchFormSubmitBtn.addEventListener('click', (e) => {
      e.preventDefault();
      triggerSearch();
    });
  }

  if (searchFilterButtons.length) {
    const updateFilterState = (activeItem = null) => {
      const parent = activeItem.closest('.search-result__filter, .search-result__sub-filter');
      const siblingButtons = parent.querySelectorAll('.search-result__filter-btn');

      siblingButtons.forEach((item) => {
        item.classList.toggle('is-active', item === activeItem);
      });
    };

    // Search Filter
    attachEvent('.search-result__filter-btn', 'click', (btn) => {
      updateFilterState(btn.target);

      const activeButtons = searchResultElem.querySelectorAll(
        '[data-category-filter] .search-result__filter-btn.is-active',
      );
      activeButtons.forEach((btn) => btn.classList.remove('is-active'));

      btn.target.classList.add('is-active');

      triggerSearch();
    });

    // Reset button
    attachEvent('.search-form__reset', 'click', (btn) => {
      const parent = btn.target.closest('.search-form');
      const input = parent.querySelector('.mod-input__field');

      setTimeout(() => {
        input.value = '';
        parent.classList.remove('has-value');
        input.focus();

        const activeButtons = searchResultElem.querySelectorAll('.search-result__filter-btn.is-active');
        activeButtons.forEach((btn) => btn.classList.remove('is-active'));

        triggerSearch();
      }, 10);
    });
  }
}
